import { render, staticRenderFns } from "./ContactingBoxRecord.vue?vue&type=template&id=353e3e25&scoped=true&"
import script from "./ContactingBoxRecord.vue?vue&type=script&lang=js&"
export * from "./ContactingBoxRecord.vue?vue&type=script&lang=js&"
import style0 from "./ContactingBoxRecord.vue?vue&type=style&index=0&id=353e3e25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353e3e25",
  null
  
)

export default component.exports